import React from 'react';

export default () => (
  <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.8275 8.92129L14.0162 3.40593V13H0V0.385445H1.40162V9.17359L5.25606 2.48787L9.81132 5.13693L12.7827 0L13.9951 0.700809L10.3299 7.04313L5.76765 4.41509L1.61887 11.5984H3.2027L6.27925 6.30027L10.8275 8.92129V8.92129Z" fill="currentColor" />
  </svg>
);
